
import log from "plugins/loglevel/index"
import Data_retriever from "app/data_retriever"
import WaitObjectByPathPromise from "app/wait_object_by_path_promise"

interface EventParams {
  event_name: string,
  options?: {
    [key: string]: unknown,
  },
}

/*
 * @see https://developers.google.com/analytics/devguides/collection/analyticsjs/events
 *
 */
const track = ({event_name, options= {}}: EventParams): void => {
  if (typeof event_name === "undefined") {
    log.debug("category missing!")
    return
  }

  log.debug(`event_name = ${event_name}`)
  log.debug(`options = ${JSON.stringify(options)}`)

  // GA4 event implementation
  /*
  * @see https://support.google.com/analytics/answer/10271001?hl=en#zippy=,in-this-article
  *
  * @see https://support.google.com/analytics/answer/10085872#event-name-rules&zippy=,in-this-article for Event Naming rules doc
  *
  * @see https://developers.google.com/tag-platform/gtagjs/reference#event for Custom event doc
  */
  WaitObjectByPathPromise("gtag")
  .then((gtag) => {
    const final_options = Object.assign({}, {
      send_to: Data_retriever.get("google-analytics-measurement-id"),
    }, options)

    gtag("event", event_name, final_options)
  })
  .catch(() => {
    log.warn("gtag is undefined!")
  })
}

export default { track }
export { track }
